import ServicePageLayout from "@/pages/services/components/ServicePageLayout";

const relatedServices = [
  { label: "Étanchéité liquide", href: "/services/etancheite-liquide" },
  { label: "Géomembranes EPDM", href: "/services/geomembranes-epdm" },
  { label: "Réfection étanchéité", href: "/services/refection-etancheite" },
  { label: "Toitures-terrasses", href: "/services/toitures-terrasses" },
  { label: "Étanchéité + isolation thermique", href: "/services/etancheite-isolation" },
];

export default function MembranesBitumineusesPage() {
  return (
    <ServicePageLayout
      tag="Technique phare"
      title="Membranes bitumineuses"
      subtitle="La solution d'étanchéité la plus éprouvée pour toitures-terrasses, parkings et ouvrages industriels en Île-de-France."
      heroImage="https://readdy.ai/api/search-image?query=professional%20roofer%20applying%20torch-on%20bituminous%20membrane%20waterproofing%20on%20large%20flat%20commercial%20rooftop%2C%20flame%20torch%20in%20action%2C%20dark%20grey%20bitumen%20surface%2C%20construction%20workers%20in%20safety%20gear%2C%20dramatic%20industrial%20photography%2C%20sharp%20detail%2C%20wide%20angle%20view%2C%20overcast%20sky&width=1440&height=900&seq=ksbtp-mb-hero-001&orientation=landscape"
      heroAlt="Pose de membranes bitumineuses KS BTP"
      intro="Les membranes bitumineuses constituent la technique d'étanchéité la plus répandue et la plus fiable pour les toitures-terrasses, parkings et ouvrages de génie civil. KS BTP maîtrise l'ensemble des procédés de mise en œuvre : soudage au chalumeau (torchage), auto-adhésif à froid et collage à chaud. Nos équipes qualifiées interviennent sur tous types de supports — béton, bois, acier — et adaptent le système multicouche aux exigences de chaque ouvrage. Chaque chantier est réalisé dans le strict respect des DTU 43.1 et des règles professionnelles en vigueur."
      techItems={[
        { icon: "ri-fire-line", label: "Soudage au chalumeau (torchage)" },
        { icon: "ri-stack-line", label: "Système bicouche & tricouche" },
        { icon: "ri-shield-check-line", label: "Membranes SBS & APP" },
        { icon: "ri-building-line", label: "Supports béton, bois, acier" },
        { icon: "ri-temp-hot-line", label: "Résistance thermique renforcée" },
        { icon: "ri-tools-line", label: "Réfection & renforcement" },
      ]}
      steps={[
        {
          number: "01",
          title: "Diagnostic du support",
          description: "Inspection visuelle et sondages du support existant pour évaluer l'état, la planéité et la compatibilité avec le nouveau système.",
        },
        {
          number: "02",
          title: "Préparation du support",
          description: "Nettoyage, ragréage des irrégularités, application d'une primaire d'accrochage pour garantir l'adhérence optimale des membranes.",
        },
        {
          number: "03",
          title: "Pose des membranes",
          description: "Mise en œuvre du système bicouche ou tricouche par torchage, avec traitement soigné des relevés, noues et points singuliers.",
        },
        {
          number: "04",
          title: "Contrôle & réception",
          description: "Test d'étanchéité, vérification des soudures et des relevés, remise du dossier de garantie décennale.",
        },
      ]}
      advantages={[
        "Technique éprouvée depuis plus de 50 ans, fiabilité maximale sur le long terme",
        "Excellente résistance aux UV, aux chocs thermiques et aux intempéries",
        "Compatibilité avec tous types de supports : béton, bois, acier, complexes isolants",
        "Système bicouche ou tricouche adapté au niveau d'exposition et de trafic",
        "Mise en œuvre rapide limitant les interruptions d'activité",
        "Garantie décennale sur l'ensemble des travaux réalisés",
        "Conformité DTU 43.1 et règles professionnelles CSFE",
      ]}
      galleryImages={[
        {
          src: "https://readdy.ai/api/search-image?query=close%20up%20detail%20of%20torch%20applied%20bituminous%20waterproofing%20membrane%20installation%2C%20roofer%20using%20propane%20torch%20to%20weld%20seams%2C%20dark%20bitumen%20surface%20texture%2C%20professional%20construction%20photography%2C%20sharp%20focus&width=600&height=440&seq=ksbtp-mb-gal-001&orientation=landscape",
          alt: "Torchage membrane bitumineuse",
        },
        {
          src: "https://readdy.ai/api/search-image?query=large%20industrial%20flat%20roof%20covered%20with%20completed%20black%20bituminous%20waterproofing%20membrane%2C%20clean%20geometric%20lines%2C%20finished%20roofing%20project%2C%20aerial%20perspective%2C%20professional%20BTP%20photography&width=600&height=440&seq=ksbtp-mb-gal-002&orientation=landscape",
          alt: "Toiture-terrasse membrane bitumineuse terminée",
        },
        {
          src: "https://readdy.ai/api/search-image?query=roofer%20applying%20bituminous%20membrane%20on%20rooftop%20edge%20and%20parapet%20wall%2C%20careful%20waterproofing%20detail%20work%20at%20roof%20perimeter%2C%20safety%20equipment%2C%20professional%20construction%20site%20France&width=600&height=440&seq=ksbtp-mb-gal-003&orientation=landscape",
          alt: "Relevé de membrane bitumineuse en acrotère",
        },
      ]}
      relatedServices={relatedServices}
    />
  );
}
